import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function Benefits() {
  const [showFirstBlock, setShowFirstBlock] = useState(true);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const toggleBlocks = () => {
    if (isTransitioning) return;

    setIsTransitioning(true);
    setTimeout(() => {
      setShowFirstBlock((prev) => !prev);
      setIsTransitioning(false);
    }, 300); // Tempo deve corresponder à duração da animação CSS
  };

  return (
    <section className="tc-benefits-style">
      <div className="container pb-120">
        <div className="d-flex align-items-center position-relative">
          <div className="col-lg-5 col-image text-center wow zoomIn slow">
            <LazyLoadImage
              src="/home_borin/assets/images/benefits/wiser.webp"
              alt="imagem do prédio da Wiser"
              className="aspect-ratio9-16 location-partial-img"
              effect="blur"
              width={"100%"}
              height={"100%"}
            />
          </div>

          <div
            id="benefits-content"
            className={`col-lg-6 ms-40 mt-20 me-40 mb-mobile font-palast-regular fade-transition ${
              !isTransitioning ? "show" : ""
            }`}
          >
            {/* Bloco 1 */}
            {showFirstBlock && (
              <div className="col-lg-6 col-12 ms-40 mt-20 me-40 mb-mobile font-palast-regular block">
                <h2 className="fsz-65 benefits-title js-splittext-lines">
                  <div className="text-white fw-400">
                    <span>
                      Economia &{" "}
                      <span className="color-brown1 font-palast-bold-italic">
                        Sustentabilidade
                      </span>
                    </span>
                  </div>
                </h2>

                <div className="text-container">
                  <div className="d-flex mt-100 wow zoomIn slow align-items-center">
                    <LazyLoadImage
                      src="/home_borin/assets/images/benefits/lamp.webp"
                      alt="ícone de uma lâmpada"
                      className="image me-10"
                      effect="blur"
                      width={"auto"}
                      height={"100%"}
                    />
                    <h3 className="fsz-24">
                      <span className="font-palast-regular lh-1">
                        Reuso da água pluvial <br /> e
                        <strong className="font-palast-bold-italic">
                          {" "}
                          iluminação LED
                        </strong>
                      </span>
                    </h3>
                  </div>

                  <p
                    className="fsz-16 color-gray mt-20 wow zoomIn slow ltspc-2 lh-1 font-neue-regular"
                    data-wow-delay="0.2s"
                  >
                    Todos os equipamentos, iluminação e elevador serão entregues
                    com alto índice de eficiência energética. O sistema de reuso
                    de água pluvial com filtros será utilizado na limpeza das
                    áreas comuns e vasos sanitários. Além disso, haverá
                    iluminação de LED em todas as áreas de lazer e de serviços.
                  </p>

                  <div className="d-flex mt-50 wow zoomIn slow align-items-center">
                    <LazyLoadImage
                      src="/home_borin/assets/images/benefits/smart.webp"
                      alt="ícone de um celular"
                      className="image me-10"
                      effect="blur"
                      width={"auto"}
                      height={"100%"}
                    />
                    <h3 className="fsz-24">
                      <span className="font-palast-regular lh-1">Smart</span>
                      <strong className="font-palast-bold-italic">
                        {" "}
                        Building
                      </strong>
                    </h3>
                  </div>

                  <p
                    className="fsz-16 color-gray mt-20 wow zoomIn slow ltspc-2 lh-1 font-neue-regular"
                    data-wow-delay="0.2s"
                  >
                    Através de um sistema de telemetria predial, o edifício
                    coleta as informações essenciais, e através desse banco de
                    dados, otimiza o funcionamento e manutenções preventivas dos
                    equipamentos, resultando em praticidade e economia.
                  </p>

                  <div className="d-flex mt-50 wow zoomIn slow align-items-center">
                    <LazyLoadImage
                      src="/home_borin/assets/images/benefits/water.webp"
                      alt="ícone lavando as mãos em uma torneira"
                      className="image me-10"
                      effect="blur"
                      width={"auto"}
                      height={"100%"}
                    />
                    <h3 className="fsz-24">
                      <strong className="font-palast-bold-italic">
                        Aquecimento
                      </strong>
                      <span className="font-palast-regular lh-1"> de água</span>
                    </h3>
                  </div>

                  <p
                    className="fsz-16 color-gray mt-20 wow zoomIn slow ltspc-2 lh-1 font-neue-regular"
                    data-wow-delay="0.2s"
                  >
                    Sistema de aquecimento de água, com placas solares e
                    equipamentos com alta eficiência. Distribuição de rede
                    própria de água quente.
                  </p>

                  <div className="d-flex mt-50 wow zoomIn slow align-items-center">
                    <LazyLoadImage
                      src="/home_borin/assets/images/benefits/pay-per-use.webp"
                      alt="ícone de uma prancheta"
                      className="image me-10"
                      effect="blur"
                      width={"auto"}
                      height={"100%"}
                    />
                    <h3 className="fsz-24">
                      <span className="font-palast-regular lh-1">
                        Condomínio
                      </span>
                      <strong className="font-palast-bold-italic">
                        {" "}
                        Pay-per-use
                      </strong>
                    </h3>
                  </div>

                  <p
                    className="fsz-16 color-gray mt-20 wow zoomIn slow ltspc-2 lh-1 font-neue-regular"
                    data-wow-delay="0.2s"
                  >
                    No sistema de condomínio pay-per-use o morador poderá optar
                    por assinar planos mensais de uso dos ambientes e serviços
                    ou pagar pelo uso individual e específico, quando for
                    conveniente a ele e conforme a sua necessidade.
                  </p>
                </div>
              </div>
            )}

            {/* Bloco 2 */}
            {!showFirstBlock && (
              <div className="col-lg-5 ms-40 mt-20 me-40 mb-mobile font-palast-regular block">
                <h2 className="fsz-65 benefits-title js-splittext-lines">
                  <div className="color-white fw-400">
                    <span>
                      Conforto &{" "}
                      <span className="color-brown1 font-palast-bold-italic">
                        Exclusividade
                      </span>
                    </span>
                  </div>
                </h2>

                <div className="text-container">
                  <div className="d-flex mt-100 wow zoomIn slow align-items-center">
                    <LazyLoadImage
                      src="/home_borin/assets/images/benefits/custom.webp"
                      alt="ícone de uma folha e um lápis"
                      className="image me-10"
                      effect="blur"
                      width={"auto"}
                      height={"100%"}
                    />
                    <h3 className="fsz-24">
                      <strong className="font-palast-bold-italic">
                        Customização{" "}
                      </strong>
                      <span className="font-palast-regular lh-1">total</span>
                    </h3>
                  </div>

                  <p
                    className="fsz-16 color-gray mt-20 wow zoomIn slow ltspc-2 lh-1 font-neue-regular"
                    data-wow-delay="0.2s"
                  >
                    O sistema estrutural eliminará todas as vigas internas e
                    permitirá alterações nos apartamentos. Será possível
                    solicitar qualquer tipo de personalização na planta durante
                    a fase de construção.
                  </p>

                  <div className="d-flex mt-50 wow zoomIn slow align-items-center">
                    <LazyLoadImage
                      src="/home_borin/assets/images/benefits/acoustic.webp"
                      alt="ícone de isolamento acústico"
                      className="image me-10"
                      effect="blur"
                      width={"auto"}
                      height={"100%"}
                    />
                    <h3 className="fsz-24">
                      <span className="font-palast-regular lh-1">
                        Melhor desempenho
                      </span>
                      <strong className="font-palast-bold-italic">
                        {" "}
                        acústico
                      </strong>
                    </h3>
                  </div>

                  <p
                    className="fsz-16 color-gray mt-20 wow zoomIn slow ltspc-2 lh-1 font-neue-regular"
                    data-wow-delay="0.2s"
                  >
                    Sistema estrutural, blocos de qualidade superior e portas
                    com vedação oferecerão um ótimo desempenho acústico nos
                    apartamentos. Opção de vidros duplos e mantas acústicas
                    serão alternativas para otimizar ainda mais o sistema de
                    proteção contra ruídos.
                  </p>

                  <div className="d-flex mt-50 wow zoomIn slow align-items-center">
                    <LazyLoadImage
                      src="/home_borin/assets/images/benefits/aut.webp"
                      alt="ícone de um celular com mais íncones em volta"
                      className="image me-10"
                      effect="blur"
                      width={"auto"}
                      height={"100%"}
                    />
                    <h3 className="fsz-24">
                      <strong className="font-palast-bold-italic">
                        Automação{" "}
                      </strong>
                      <span className="font-palast-regular lh-1">
                        nos apartamentos
                      </span>
                    </h3>
                  </div>

                  <p
                    className="fsz-16 color-gray mt-20 wow zoomIn slow ltspc-2 lh-1 font-neue-regular"
                    data-wow-delay="0.2s"
                  >
                    O sistema de automação será instalado na unidade privativa
                    para: iluminação, persianas elétricas, sistemas de som,
                    equipamentos de áudio e vídeo e fechadura biométrica na
                    porta de entrada.
                  </p>

                  <div className="d-flex mt-50 wow zoomIn slow align-items-center">
                    <LazyLoadImage
                      src="/home_borin/assets/images/benefits/garage.webp"
                      alt="ícone de uma garagem"
                      className="image me-10"
                      effect="blur"
                      width={"auto"}
                      height={"100%"}
                    />
                    <h3 className="fsz-24">
                      <strong className="font-palast-bold-italic">Car </strong>
                      <span className="font-palast-regular lh-1">friendly</span>
                    </h3>
                  </div>

                  <p
                    className="fsz-16 color-gray mt-20 wow zoomIn slow ltspc-2 lh-1 font-neue-regular"
                    data-wow-delay="0.2s"
                  >
                    Serão disponibilizadas tomadas individuais de carros
                    elétricos em cada vaga de garagem. Além disso, a garagem do
                    condomínio contará com ambiente para lavagem e estética
                    automotiva. O ambiente poderá ser utilizado pelo morador ou
                    por um profissional especializado.
                  </p>
                </div>
              </div>
            )}
          </div>

          {/* Botão de alternância */}
          <div className="col-12 d-flex justify-content-end align-items-end mt-5 position-absolute bottom-0 btn">
            <button
              className="circle-arrow wow zoomIn slow me-100"
              onClick={toggleBlocks}
            >
              <i className="far fa-long-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Benefits;
